import { defineComponent as s, withDirectives as i, inject as o } from "vue";
import { getFirstVNode as r } from "./highrise666.mjs";
const g = s({
  name: "Target",
  setup() {
    const { setTargetRef: e, syncTarget: t } = o("VBinder");
    return {
      syncTarget: t,
      setTargetDirective: {
        mounted: e,
        updated: e
      }
    };
  },
  render() {
    const { syncTarget: e, setTargetDirective: t } = this;
    return e ? i(r("follower", this.$slots), [
      [t]
    ]) : r("follower", this.$slots);
  }
});
export {
  g as default
};
